<template lang="pug">
a(@click="save")
  v-img(:src="icon", width="360")
</template>

<script>
export default {
  props: ["event", "ticket", "time_items", "ticket_item"],
  data() {
    return {
      icon: "https://firebasestorage.googleapis.com/v0/b/selflane-docs.appspot.com/o/icons%2FSave%20to%20Google%20Pay%20-%20English%20(Dark).svg?alt=media&token=ba2a2a94-a0bb-4b55-af6e-bd56a59e7ccf",
    };
  },
  methods: {
    save() {
      console.log("save");
      let data = {
        passTypeIdentifier: "ticket",
        teamIdentifier: "CLU6U824VM",
        description: "Ticket for a local event",
        logoText: this.event.title,
        ticket: {
          primaryFields: [
            {
              key: "offer",
              value: this.ticket_item.name,
              label: this.ticket.ticket_number,
            },
          ],
        },
      };
      console.log(data);
    },
  },
};
</script>